<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="27.429" height="24" viewBox="0 0 27.429 24">
        <path id="Caminho_10533" data-name="Caminho 10533" d="M10.425,32H17a2.565,2.565,0,0,1,2.438,1.758L20,35.429h4a3.432,3.432,0,0,1,3.429,3.429V52.571A3.432,3.432,0,0,1,24,56H3.429A3.43,3.43,0,0,1,0,52.571V38.857a3.43,3.43,0,0,1,3.429-3.429h4l.557-1.67A2.565,2.565,0,0,1,10.425,32Zm3.289,18.857a5.143,5.143,0,1,0,0-10.286,5.143,5.143,0,0,0,0,10.286Z" transform="translate(0 -32)" fill="#fff"/>
    </svg>
</template>
